import axios from "axios";

const instance = axios.create({
  baseURL: 'https://react-burger-builder-8007c-default-rtdb.firebaseio.com/',
});

export default instance;